import type { TFunction } from 'i18next';

import { DTO_MESSAGE_INFO_MESSAGE_CONTENT_TYPES } from 'src/apis/dto/DTOMessageInfo';
import type { DTOMessageThreadInfo } from 'src/apis/dto/DTOMessageThreadInfo';

export const getMessageSummary = (
  messageThreadInfo: Pick<
    DTOMessageThreadInfo,
    'friendInfo' | 'lastMessage' | 'lastMessageSentByMe'
  >,
  t: TFunction<'translation', undefined>
): string => {
  const {
    lastMessageSentByMe,
    lastMessage,
    friendInfo: { simpleName },
  } = messageThreadInfo;

  if (lastMessage?.startsWith(DTO_MESSAGE_INFO_MESSAGE_CONTENT_TYPES.IMAGE)) {
    return lastMessageSentByMe
      ? t('MESSAGING.YOU_SENT_A_PHOTO')
      : t('MESSAGING.PEER_SENT_A_PHOTO', { user: simpleName });
  }

  return t(lastMessage ?? '');
};
